export enum KioskStatus {
  INACTIVE = 'inactive',
  RESUMING = 'resuming',
  ACTIVE = 'active',
}
